import { render, staticRenderFns } from "./infoGeneral.vue?vue&type=template&id=8555845c"
import script from "./infoGeneral.vue?vue&type=script&lang=js"
export * from "./infoGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports